<app-masterpage>
</app-masterpage>
<div class="page-wrapper">
    <app-header>
    </app-header>
    <div class="container-fluid pt-custom pb-5">
        <!-- onclick="outerbody();" -->
        <div class="row">
            <div class="col-lg-12">
                <div class="header">
                    <h4 class="title">Scholarship Detail {{schoolname}}</h4>
                </div>
                <div class="row justify-content-center card">
                    <div class="col-lg-12 col-md-12 col-12 p-4">
                        <form #scholarshipDetail="ngForm" (ngSubmit)="onSubmit(data)" class="pb-3">
                            <div class="row">
                                <div class="col-lg-4 col-md-4 col-12">
                                    <label class="form-label "><b>Course</b><span class="text-danger">
                                            *</span></label>
                                    <select class="form-control" #StandardID="ngModel" ngModel name="StandardID"
                                        [(ngModel)]="data.StandardID" required>
                                        <option *ngFor="let s of std" [value]="s.value"
                                            [selected]="data.StandardID == s.value">
                                            {{ s.text }}
                                        </option>
                                    </select>
                                    <span *ngIf="submitted ">
                                        <p *ngIf="data.StandardID == 0 || data.StandardID == undefined"
                                            class="error_message" style="color: red">
                                            Course is required
                                        </p>
                                    </span>
                                </div>
                                <div class="col-lg-4 col-md-4 col-12">
                                    <label class="form-label "><b>Medium</b><span class="text-danger"> *</span></label>
                                    <select class="form-control" #MediumID="ngModel" ngModel name="MediumID"
                                        [(ngModel)]="data.MediumID" required>
                                        <option *ngFor="let medium of mediums" [value]="medium.value"
                                            [selected]="data.MediumID == medium.value">
                                            {{ medium.text }}
                                        </option>
                                    </select>
                                    <span *ngIf="submitted ">
                                        <p *ngIf="data.MediumID == 0 || data.MediumID == undefined"
                                            class="error_message" style="color: red">
                                            Medium is required
                                        </p>
                                    </span>
                                </div>
                                <div class="col-lg-4 col-md-4 col-12">
                                    <div class="form-group">
                                        <label class="form-label "><b>Academic year</b><span class="text-danger">
                                                *</span></label>
                                        <select class="form-control" #AcademicYearID="ngModel" ngModel
                                            name="AcademicYearID" [(ngModel)]="data.AcademicYearID" required>
                                            <option *ngFor="let year of years" [value]="year.value"
                                                [selected]="data.AcademicYearID == year.value">
                                                {{ year.text }}
                                            </option>
                                        </select>
                                        <span *ngIf="submitted ">
                                            <p *ngIf="data.AcademicYearID == 0 || data.AcademicYearID == undefined"
                                                class="error_message" style="color: red">
                                                Academic year is required
                                            </p>
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-lg-4 col-md-4 col-12">
                                    <div class="form-group">
                                        <label class="form-label "><b>Scholarship type</b><span class="text-danger">
                                                *</span></label>
                                        <select class="form-control" #ScholarshipTypeID="ngModel" ngModel
                                            name="ScholarshipTypeID" [(ngModel)]="data.ScholarshipTypeID" required>
                                            <option *ngFor="let scholarshiptype of scholarshiptypes"
                                                [value]="scholarshiptype.value"
                                                [selected]="data.ScholarshipTypeID == scholarshiptype.value">
                                                {{ scholarshiptype.text }}
                                            </option>
                                        </select>
                                        <span *ngIf="submitted ">
                                            <p *ngIf="data.ScholarshipTypeID == 0 || data.ScholarshipTypeID == undefined"
                                                class="error_message" style="color: red">
                                                Scholarship type is required
                                            </p>
                                        </span>
                                    </div>
                                </div>
                                <div class="col-lg-4 col-md-4 col-12">
                                    <div class="form-group">
                                        <label class="form-label "><b>Student name</b><span class="text-danger">
                                                *</span></label>
                                        <input class="form-control" type="text" name="StudName"
                                            placeholder="Enter student name" [(ngModel)]="data.StudName" #StudName="ngModel"
                                            ngModel maxlength="100" autocomplete="off" required />
                                        <span *ngIf="submitted && StudName.invalid">
                                            <p *ngIf="StudName.errors.required" class="error_message"
                                                style="color: red">
                                                Student name is required
                                            </p>
                                        </span>
                                    </div>
                                </div>
                                <div class="col-lg-4 col-md-4 col-12">
                                    <div class="form-group">
                                        <label class="form-label "><b>Gr no.</b><span class="text-danger">
                                                *</span></label>
                                        <input class="form-control" type="text" name="GrNo"
                                            placeholder="Enter Gr no." [(ngModel)]="data.GrNo" #GrNo="ngModel"
                                            ngModel maxlength="20" autocomplete="off" required />
                                        <span *ngIf="submitted && GrNo.invalid">
                                            <p *ngIf="GrNo.errors.required" class="error_message"
                                                style="color: red">
                                                Gr no. is required
                                            </p>
                                        </span>
                                    </div>
                                </div>
                                <div class="col-lg-4 col-md-4 col-12">
                                    <div class="form-group">
                                        <label class="form-label "><b>Amount</b><span
                                                class="text-danger">*</span></label>
                                        <input class="form-control" type="text" name="Amount" placeholder="Enter amount"
                                            [(ngModel)]="data.Amount" maxlength="15" autocomplete="off"
                                            (keypress)="onlyDouble($event,data.Amount)" #Amount="ngModel" ngModel
                                            required />
                                        <span *ngIf="submitted && Amount.invalid">
                                            <p *ngIf="Amount.errors.required" class="error_message" style="color: red">
                                                Amount is required
                                            </p>
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div class="mb-3">
                                <button class="btn btn-success" type="submit" style="margin: 5px;">{{btnsubmittext}}</button>
                                <button class="btn btn-primary" type="button" (click)="resetForm()"
                                    style="margin: 5px;">Clear</button>
                                <button type="button" class="btn btn-danger" (click)="Cancel()">Cancel</button>
                            </div>
                        </form>
                        <div class="row">
                            <div class="col-lg-12 col-md-12 col-12">
                                <div class="table-responsive subject">
                                    <div
                                        *ngIf="scholarshipDetailList != undefined && scholarshipDetailList.length != 0">
                                        <div class="card col-mb-6">
                                            <div class="card-header py-3">
                                                <input type="text" class="form-control bg-white border-0 small"
                                                    placeholder="Search for..." [(ngModel)]="searchtext"
                                                    aria-label="Search" aria-describedby="basic-addon2"
                                                    (keyup)="setpage()" />
                                            </div>
                                        </div>
                                        <table id="example" class="table table-striped table-bordered"
                                            style="width:100%">
                                            <thead>
                                                <tr>
                                                    <th class="pointer" scope="col" (click)="sortBy('SrNo')">Sr. No.
                                                    </th>
                                                    <th class="pointer" scope="col" (click)="sortBy('Standard')">Course</th>
                                                    <th class="pointer" scope="col" (click)="sortBy('Medium')">Medium</th>
                                                    <th class="pointer" scope="col" (click)="sortBy('AcademicYear')">Academic year</th>
                                                    <th class="pointer" scope="col" (click)="sortBy('ScholarshipType')">Scholarship type </th>
                                                    <th class="pointer" scope="col" (click)="sortBy('StudName')">Student name</th>
                                                    <th class="pointer" scope="col" (click)="sortBy('GrNo')">Gr no.</th>
                                                    <th class="pointer" scope="col" (click)="sortBy('Amount')">Amount</th>
                                                    <!-- <th class="pointer" scope="col" (click)="sortBy('FeesCollected')">Fees collected</th>
                                                    <th class="pointer" scope="col" (click)="sortBy('FeesIncreased')">Fees increased</th>
                                                    <th class="pointer" scope="col" (click)="sortBy('FeesProposal')">Fees proposal</th> -->
                                                    <th class="pointer" scope="col">Action</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr
                                                    *ngFor="let r of scholarshipDetailList | filter:searchtext | paginate: { itemsPerPage: pageLimit, currentPage: p };let i = index">
                                                    <td>{{r.SrNo}}</td>
                                                    <td>
                                                        <p>{{r.Standard}}</p>
                                                    </td>
                                                    <td>
                                                        <p>{{r.Medium}}</p>
                                                    </td>
                                                    <td>
                                                        <p>{{r.AcademicYear}}</p>
                                                    </td>
                                                    <td>
                                                        <p>{{r.ScholarshipType}}</p>
                                                    </td>
                                                    <td>
                                                        <p>{{r.StudName}}</p>
                                                    </td>
                                                    <td>
                                                        <p>{{r.GrNo}}</p>
                                                    </td>
                                                    <td>
                                                        <p>{{r.Amount}}</p>
                                                    </td>
                                                    <!-- <td>
                                                        <p>{{r.FeesCollected}}</p>
                                                    </td>
                                                    <td>
                                                        <p>{{r.FeesIncreased}}</p>
                                                    </td>
                                                    <td>
                                                        <p>{{r.FeesProposal}}</p>
                                                    </td> -->
                                                    <td>
                                                        <!-- <div *ngIf="r.status == 'Not Approved'"> -->
                                                        <button type="button" class="btn btn-success rmb_10"
                                                            (click)="editScholarshipDetail(r.HashCode)">Edit</button>
                                                        &nbsp; <button type="button" class="btn btn-danger"
                                                            (click)="deleteScholarshipDetail(r.HashCode)">Delete</button>
                                                        <!-- </div> -->
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                        <div class="card-footer pb-0 pt-3" align="right">
                                            <pagination-controls (pageChange)="p = $event"></pagination-controls>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="footer-login custom-footer">
        <p class="mb-0">Copyright © Netsol IT Solution Pvt. Ltd. 2020 All Rights Reserved</p>
        <img src="assets/images/powered-by.png" alt="netsol-powerd by" class="img-fluid">
    </div>
    <ngx-spinner bdcolor="rgba(51, 51, 51, 0.8)" size="default" type="ball-spin-clockwise">
        <p style="color: white;">Please Wait.</p>
    </ngx-spinner>
</div>